import { Box, Button, Heading, Text } from "@primer/react";
import { LockIcon, MailIcon, SignOutIcon, DeviceMobileIcon } from "@primer/octicons-react";
import { useNavigate } from "react-router-dom";
import { appConst } from "../../AppConst";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { rootActions } from "../../state/actions/rootActions";

const PeriodClosedPage = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { daoTao } = appConst.support;

    const handleLogout = () => {
        dispatch(rootActions.auth.LOGOUT());
        navigate("/login", { replace: true });
    };

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                bg: "canvas.inset",
                px: 3,
                py: 4,
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    maxWidth: 520,
                    textAlign: "center",
                    bg: "canvas.default",
                    borderRadius: 4,
                    p: [4, 5],
                    boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                    border: "1px solid",
                    borderColor: "border.muted",
                }}
            >
                <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
                    <Box
                        sx={{
                            width: 80,
                            height: 80,
                            borderRadius: "50%",
                            bg: "danger.subtle",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "danger.fg",
                        }}
                    >
                        <LockIcon size={36} />
                    </Box>
                </Box>

                <Heading as="h1" sx={{ fontSize: 5, mb: 2, fontWeight: 700 }}>
                    Cổng đăng ký đã đóng
                </Heading>
                <Text sx={{ color: "fg.muted", fontSize: 1, display: "block", mb: 4, lineHeight: 1.5 }}>
                    Đợt đăng ký tín chỉ hiện tại đã kết thúc. Vui lòng đợi thông báo từ Phòng Đào tạo về đợt tiếp theo.
                </Text>

                {(daoTao.email || daoTao.phone) && (
                    <Box
                        sx={{
                            bg: "canvas.subtle",
                            borderRadius: 2,
                            p: 3,
                            mb: 4,
                            textAlign: "left",
                        }}
                    >
                        <Text sx={{ fontSize: 0, color: "fg.muted", display: "block", mb: 2, fontWeight: 600 }}>
                            CẦN HỖ TRỢ?
                        </Text>
                        <Text sx={{ fontSize: 1, color: "fg.default", display: "block", mb: 1, fontWeight: 600 }}>
                            {daoTao.name}
                        </Text>
                        {daoTao.email && (
                            <Box
                                as="a"
                                href={`mailto:${daoTao.email}`}
                                sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 1,
                                    fontSize: 1,
                                    color: "accent.fg",
                                    textDecoration: "none",
                                    mr: 3,
                                    ":hover": { textDecoration: "underline" },
                                }}
                            >
                                <MailIcon size={14} /> {daoTao.email}
                            </Box>
                        )}
                        {daoTao.phone && (
                            <Box
                                as="a"
                                href={`tel:${daoTao.phone.replace(/\./g, "")}`}
                                sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 1,
                                    fontSize: 1,
                                    color: "accent.fg",
                                    textDecoration: "none",
                                    ":hover": { textDecoration: "underline" },
                                }}
                            >
                                <DeviceMobileIcon size={14} /> {daoTao.phone}
                            </Box>
                        )}
                    </Box>
                )}

                <Button variant="default" leadingVisual={SignOutIcon} onClick={handleLogout} size="medium">
                    Đăng xuất
                </Button>
            </Box>
        </Box>
    );
};

export default PeriodClosedPage;
